<template>
    <div class="pt-4 px-4 pb-8" data-cy="container_survey_result">
        <div class="pb-4">
            <img class="w-[160px] h-10" :src="getLogoImage()" alt="">
        </div>
        <div class="border border-a-gray-C8C8CC rounded-[30px] pt-8 px-4 pb-4" :style="{'box-shadow': '0 4px 4px 0 rgba(0, 0, 0, 0.25)'}">
            <img class="w-[224px] h-[190px] mx-auto" :src="getAnimalImage()" alt="animal image">
            <div class="pt-4 text-center font-medium text-24 pb-6">
                <span>{{ lbl.golden_question.result.you_are }}</span> 
                <span class="text-a-blue-0064ff">{{ lbl.golden_question.result.animal[animal] }}</span>
            </div>
            <div class="flex flex-col w-full gap-4">
            <div class="" v-for="(item, index) in animalList.find(a => a.name === animal).description" :key="index">
                <div :style="{
                        'border': `1px solid ${animalList.find(a => a.name === animal).color[index + 1].header}`,
                        'background-color': animalList.find(a => a.name === animal).color[index + 1].bg,
                        'color': animalList.find(a => a.name === animal).color[index + 1].header
                    }" 
                    class="rounded-[20px] py-1 px-4 font-medium bg-white z-10 relative">
                    {{ item.title }}
                </div>


                <div class="px-4 pb-2 pt-6 -mt-4 rounded-b-3xl relative z-0" 
                    :style="{
                        'border': `1px solid ${animalList.find(a => a.name === animal).color[index + 1].header}`,
                    }" >{{ item.detail }}</div>
            </div>
            </div>

        </div>
        <div class="pt-8 px-4 pb-14">
            <div class="font-medium pb-4">{{ lbl.golden_question.result.you_are_in_group }}</div>
            <div class="">{{ animalList.find(a => a.name === animal).group_detail }}</div>
            <div class="pt-1">อยากรู้ไหมว่าเพื่อนของคุณอยู่กลุ่มไหน?</div>
            <div class="pt-1 pb-4">ชวนเพื่อนมาเล่นแบบทดสอบกันเถอะ!</div>
            <div class="">
                <img class="mx-auto" :src="getPercentageImage()" alt="percentage image">
            </div>
            <div class="pt-4 text-14">
                จำนวน % ของคนที่ทำแบบทดสอบนี้และได้ผลลัพธ์เดียวกับคุณ เป็นการอ้างอิงข้อมูลจากผลการวิจัยพฤติกรรมผู้บริโภคปี 2567 ของธนาคาร
            </div>
        </div>
        <div class="mx-4">
            <div class="w-full bg-a-blue-0064ff text-white flex justify-center items-cente font-medium rounded-xl px-6 py-3.5"
                data-cy="btn_survey_result_plankton"
                @click="$emit('goToPlankton')">
                {{ lbl.golden_question.result.see_plankton }}
            </div>
        </div>
    </div>
</template>
<script>
import ConfigManager from '@/config/ConfigManager.js';
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    name: "Result",
    mixins: [LocaleMixin],
    props: {
        animal: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            animalList: [
                {
                    name: 'otter',
                    description: [
                        {
                            title: 'รอบคอบ',
                            detail: 'เหมือนนากที่โตมากับฝูง คุณเป็นคนที่เรียนรู้จากคนรอบตัวเสมอ ไม่ว่าจะเป็นเพื่อน ครอบครัว หรือคนที่คุณไว้ใจ ก่อนการตัดสินใจเรื่องสำคัญ'
                        },
                        {
                            title: 'ไหลตามน้ำ',
                            detail: 'คุณอยากตามให้ทันกระแสทั้งเรื่องเงินและไลฟ์สไตล์ เหมือนนากที่ต้องปรับตัวเพื่อเข้ากลุ่ม'
                        },
                        {
                            title: 'สายชิล',
                            detail: 'คุณสนุกกับชีวิตอย่างเต็มที่ แต่ก็ฉลาดเลือกและมีความรับผิดชอบต่ออนาคต เหมือนกับนากที่แม้จะเล่นน้ำอย่างสนุกสนาน แต่ก็สามารถเอาตัวรอดได้'
                        },
                    ],
                    color: {
                        1: {
                            header: '#002850',
                            bg: '#E8F1FF'
                        },
                        2: {
                            header: '#44195B',
                            bg: '#F7EBFF'
                        },
                        3: {
                            header: '#7A0334',
                            bg: '#FEDCD7'
                        }
                    },
                    group_detail: '17% ของคนที่ทำแบบทดสอบนี้เป็นนากช่างสงสัย'
                },
                {
                    name: 'cat',
                    description: [
                        {
                            title: 'มีความสุขกับปัจจุบัน',
                            detail: 'เหมือนกับน้องเหมียว คุณมีความสุขกับปัจจุบัน ใช้ชีวิตเพื่อวันนี้ แทนที่จะกังวลกับวันพรุ่งนี้'
                        },
                        {
                            title: 'มุ่งมั่น',
                            detail: 'คุณเลือกทำในสิ่งที่รักและมีเส้นทางชีวิตของตนเอง กล้าลุยเพื่อโอกาสใหม่ ๆ และไม่ลังเลที่จะลงมือทำเพื่อคนที่คุณรัก'
                        },
                        {
                            title: 'เห็นอกเห็นใจ',
                            detail: 'คุณอ่อนโยนและใส่ใจ ให้ค่ากับความสัมพันธ์มากกว่าวัตถุ เหมือนกับน้องเหมียวที่แสดงความห่วงใยผ่านการกระทำเล็ก ๆ แต่เปี่ยมไปด้วยความหมาย'
                        },
                    ],
                    color: {
                        1: {
                            header: '#083D37',
                            bg: '#E4F7E8'
                        },
                        2: {
                            header: '#44195B',
                            bg: '#F7EBFF'
                        },
                        3: {
                            header: '#002850',
                            bg: '#E8F1FF'
                        }
                    },
                    group_detail: '14% ของคนที่ทำแบบทดสอบนี้เป็นเหมียวนักผจญภัย'
                },
                {
                    name: 'corgi',
                    description: [
                        {
                            title: 'ทันกระแส',
                            detail: 'เหมือนคอร์กี้ที่มั่นใจและมีเสน่ห์ การลงทุนของคุณไม่ใช่แค่เรื่องตัวเลข แต่สะท้อนสไตล์และตัวตนของคุณอย่างแท้จริง'
                        },
                        {
                            title: 'มีไหวพริบ',
                            detail: 'คุณใช้ชีวิตอย่างฉลาดและรอบคอบ มีสัญชาตญาณที่ดีในการตัดสินใจ และรู้จักบริหารค่าใช้จ่ายอย่างมีเป้าหมาย'
                        },
                        {
                            title: 'พร้อมเปิดใจ',
                            detail: 'คุณเปิดรับประสบการณ์ใหม่เสมอ โดยเฉพาะเมื่อมีสิ่งดี ๆ รออยู่ข้างหน้า'
                        },
                    ],
                    color: {
                        1: {
                            header: '#270C35',
                            bg: '#F7EBFF'
                        },
                        2: {
                            header: '#7A0334',
                            bg: '#FCECE8'
                        },
                        3: {
                            header: '#7E330B',
                            bg: '#FEE6D6'
                        }
                    },
                    group_detail: '26% ของคนที่ทำแบบทดสอบนี้เป็นคอร์กี้จอมมุ่งมั่น'
                },
                {
                    name: 'tiger',
                    description: [
                        {
                            title: 'รักอิสระ',
                            detail: 'เหมือนกับเสือ คุณไม่ชอบพึ่งใคร เชื่อมั่นในสัญชาตญาณของตัวเอง และพร้อมสร้างชีวิตในแบบที่คุณเลือก'
                        },
                        {
                            title: 'ทะเยอทะยาน',
                            detail: 'คุณรอจังหวะอย่างชาญฉลาดก่อนจะพุ่งไปข้างหน้า ทุกก้าวของคุณมีแผนเพื่อให้แน่ใจว่าทั้งตัวคุณและคนที่คุณรักจะมั่นคงและไปได้ไกล'
                        },
                        {
                            title: 'ใช้สัญชาตญาณ',
                            detail: 'คุณเชื่อในสัญชาตญาณของตัวเอง เวลาตัดสินใจ คุณฟังเสียงจากข้างใน และไม่ว่าจะเริ่มค้นคว้าเรื่องอะไร ก็ใส่ใจในรายละเอียดและทำอย่างรอบคอบเสมอ'
                        },
                    ],
                    color: {
                        1: {
                            header: '#7E330B',
                            bg: '#FEE6D6'
                        },
                        2: {
                            header: '#44195B',
                            bg: '#F7EBFF'
                        },
                        3: {
                            header: '#083D37',
                            bg: '#E4F7E8'
                        }
                    },
                    group_detail: '14% ของคนที่ทำแบบทดสอบนี้เป็นเสือจอมวางแผน'
                },
                {
                    name: 'bee',
                    description: [
                        {
                            title: 'มีวิสัยทัศน์',
                            detail: 'เหมือนผึ้งที่ขยันสร้างรังเพื่ออนาคต คุณมองหาโอกาสลงทุนที่มั่นคง และพร้อมลงมือเพื่อสร้างความเติบโตในระยะยาว'
                        },
                        {
                            title: 'พึ่งพาได้',
                            detail: 'คุณเป็นคนทุ่มเท มุ่งมั่นสร้างความมั่นคงและปลอดภัยให้ตนเอง และครอบครัว'
                        },
                        {
                            title: 'ชอบลงมือทำ',
                            detail: 'คุณติดตามข้อมูลและกระแสต่าง ๆ อย่างใส่ใจ และเลือกมาปรับใช้ เพื่อสร้างความมั่นคงในแบบของตัวเอง เหมือนผึ้งที่ค่อย ๆ เก็บน้ำหวานเพื่อหล่อเลี้ยงรังให้เติบโต'
                        },
                    ],
                    color: {
                        1: {
                            header: '#002850',
                            bg: '#E8F1FF'
                        },
                        2: {
                            header: '#44195B',
                            bg: '#F7EBFF'
                        },
                        3: {
                            header: '#574A06',
                            bg: '#FFF8D4'
                        }
                    },
                    group_detail: '11% ของผู้ที่ทำแบบทดสอบนี้เป็นผึ้งจอมอึด'
                },
                {
                    name: 'penguin',
                    description: [
                        {
                            title: 'ใส่ใจครอบครัว',
                            detail: 'เหมือนเพนกวิน คุณให้ความสำคัญกับการใช้เวลาคุณภาพกับครอบครัว เพราะสำหรับคุณ นี่คือการลงทุนที่มีค่าที่สุด'
                        },
                        {
                            title: 'ติดดิน',
                            detail: 'คุณไม่ได้มองหาชื่อเสียงหรือทรัพย์สิน เพราะคุณเชื่อว่าความมั่งคั่งที่แท้จริง คือคุณค่าและวัฒนธรรมที่สร้างร่วมกันในครอบครัว'
                        },
                        {
                            title: 'รอบคอบ',
                            detail: 'คุณไม่รีบตามกระแสหรือเสี่ยงโดยไม่จำเป็น เพราะคุณเชื่อในการเดินตามเส้นทางที่มั่นคงและคุ้นเคย เหมือนเพนกวินที่เลือกอยู่กับสิ่งที่ปลอดภัยและวางใจได้'
                        },
                    ],
                    color: {
                        1: {
                            header: '#7E330B',
                            bg: '#FEE6D6'
                        },
                        2: {
                            header: '#062C29',
                            bg: '#E4F7E8'
                        },
                        3: {
                            header: '#002850',
                            bg: '#E8F1FF'
                        }
                    },
                    group_detail: '18% ของผู้ที่ทำแบบทดสอบนี้เป็นเพนกวินรักสงบ'
                },
            ]
        };
    },
    methods: {
        getAnimalImage: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/animal/${this.animal}.png`;
        },
        getPercentageImage: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/animal/percen-${this.animal}.png`;
        },
        getLogoImage: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/icons/golden-question/logo-bbl.svg`;
        }
    },
    mounted() {
    }
}
</script>
<style scoped lang="scss">
</style>